import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Row, Col, Card, CardBody, CardTitle, Modal, Form } from "reactstrap"

// assets
import "../../../../assets/css/Sales/Sales.css"
import userImg from "../../../../assets/images/users/AdminImg.png"
import moment from "moment"

const ViewNotes = ({ introducer_note, introducer_assign }) => {
  const [viewFollowUp, setViewFollowUp] = useState(false)

  const [notes, setNotes] = useState([])
  const [assign, setAssigned] = useState("")

  const onGetAssign = note => {
    setViewFollowUp(true)
    setNotes(note?.introducer_followup[0])
    const idArrays = note?.introducer_followup[0].assign_user
      ?.split(",")
      .map(Number)
    const filteredArray = introducer_assign.filter(item =>
      idArrays.includes(item.value)
    )
    const resultString = filteredArray.map(item => item.label).join(", ")
    setAssigned(resultString)
  }

  return (
    <React.Fragment>
      <div className="mb-3">
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-5 text-dark">Notes</CardTitle>
            
                <div>
                  <ul className="verti-timeline list-unstyled notes-box">
                   
                    <li  className="event-list position-relative">
                      <div className="event-timeline-dot">
                        <img
                          src={userImg}
                          className="userImg me-3"
                          alt="User"
                        />
                      </div>
                      <div className="d-flex">
                        <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="text-muted mb-4">
                                <h6 className="d-inline me-2">By Admin</h6>
                                09-10-2024 11:13:14
                                <span className="pl-15">
                                  Got in touch with this Freelancer at
                                  12-10-2024 9:30:00
                                </span>
                              </p>
                              <i className="bi bi-triangle-fill note-icon"></i>
                            </div>
                      
                          </div>
                          <div
                            className="Features"
                            dangerouslySetInnerHTML={{
                              __html:
                                "<p>This is a static note description.</p>",
                            }}
                          />
                          <div>
                            <div>
                              Attachment:{" "}
                              <a
                                target="_blank"
                                rel="noreferrer"
                                className="activity-log-btn text-info"
                                href="https://example.com/static-attachment.pdf" // Replace with your static link
                              >
                                <i className="fas fa-eye pr-10"></i>View
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li  className="event-list position-relative">
                      <div className="event-timeline-dot">
                        <img
                          src={userImg}
                          className="userImg me-3"
                          alt="User"
                        />
                      </div>
                      <div className="d-flex">
                        <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="text-muted mb-4">
                                <h6 className="d-inline me-2">By Admin</h6>
                                09-10-2024 11:13:14
                                <span className="pl-15">
                                  Got in touch with this Freelancer at
                                  12-10-2024 9:30:00
                                </span>
                              </p>
                              <i className="bi bi-triangle-fill note-icon"></i>
                            </div>
                            {/* <div className="me-4">
                              <span
                                onClick={() => {
                         
                                  setAddFollowUp(true)
                        
                                }}
                                className="me-2 cursor-pointer badge-soft-success badge"
                              >
                                Add FollowUp
                              </span>
                              <button
                                onClick={e => {
                                  e.preventDefault()
                                  setEditNotesSidebar(true)
                                }}
                                className="btn btn-sm edit-delete-btn text-success me-2"
                              >
                                <i className="fas fa-edit" title="Edit"></i>
                              </button>
                              <button
                                className="btn btn-sm edit-delete-btn text-danger"
                                // onClick={deleteNote}
                              >
                                <i
                                  className="fas fa-trash-alt"
                                  title="Delete"
                                ></i>
                              </button>
                            </div> */}
                          </div>
                          <div
                            className="Features"
                            dangerouslySetInnerHTML={{
                              __html:
                                "<p>This is a static note description.</p>",
                            }}
                          />
                          <div>
                            <div>
                              Attachment:{" "}
                              <a
                                target="_blank"
                                rel="noreferrer"
                                className="activity-log-btn text-info"
                                href="https://example.com/static-attachment.pdf" // Replace with your static link
                              >
                                <i className="fas fa-eye pr-10"></i>View
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li  className="event-list position-relative">
                      <div className="event-timeline-dot">
                        <img
                          src={userImg}
                          className="userImg me-3"
                          alt="User"
                        />
                      </div>
                      <div className="d-flex">
                        <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="text-muted mb-4">
                                <h6 className="d-inline me-2">By Admin</h6>
                                09-10-2024 11:13:14
                                <span className="pl-15">
                                  Got in touch with this Freelancer at
                                  12-10-2024 9:30:00
                                </span>
                              </p>
                              <i className="bi bi-triangle-fill note-icon"></i>
                            </div>
                         
                          </div>
                          <div
                            className="Features"
                            dangerouslySetInnerHTML={{
                              __html:
                                "<p>This is a static note description.</p>",
                            }}
                          />
                          <div>
                            <div>
                              Attachment:{" "}
                              <a
                                target="_blank"
                                rel="noreferrer"
                                className="activity-log-btn text-info"
                                href="https://example.com/static-attachment.pdf" // Replace with your static link
                              >
                                <i className="fas fa-eye pr-10"></i>View
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* ) */}
                    {/* })} */}
                  </ul>

               
                
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* View Follow Up Modal */}
      <Modal
        isOpen={viewFollowUp}
        size="sm"
        className="bd-custom-md-3"
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">View Follow Up</h5>
          <button
            type="button"
            onClick={() => {
              setViewFollowUp(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form className="row bd-span-input">
            <>
              <div className="mb-3 col-12">
                <label htmlFor="formrow-firstname-Input">Date</label>
                <div className="input-span">{notes.date_time}</div>
              </div>
              <div className="mb-3 col-12">
                <label htmlFor="">Purpose</label>
                <div className="input-span">{notes.description}</div>
              </div>
              <div className="mb-3 col-12">
                <label htmlFor="">Assigned</label>
                <div className="input-span">{assign}</div>
              </div>
            </>
          </Form>
        </div>
      </Modal>
      {/* -------------- */}
    </React.Fragment>
  )
}

export default ViewNotes
